import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_social_media.breadcrumb.social_media_app_label'),
    link: '/application',
  },
  {
    label: t('pages.application_social_media.breadcrumb.social_media_label'),
    link: '/application/social-media',
  },
  {
    label: t('pages.application_social_media.breadcrumb.social_media_links_label'),
  },
];
